import { ShiftSessionListPage } from "@/features/user-shift/pages/ShiftSessionListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/user-shift/")({
	beforeLoad({ context }) {
		if (!context.authAdapter.can({ permissions: ["shift_session.view"] })) {
			throw redirect({ to: "/403" });
		}
	},
	component: ShiftSessionListPage,
});
